import * as CONSTANTS from '../constants';

import {
  EMAIL_AT_ERROR,
  EMAIL_DOMAIN_ERROR,
  INTERESTED_PRODUCT,
  MINIMUM_NAME_LENGTH_ERROR,
  PHONE_NUMBER_ERROR,
  PROFESSIONAL_EMAIL_ERROR,
  REQUIRED_FIELD_ERROR,
  VALIDATOR_FAILURE,
  VALIDATOR_SUCCESS,
} from './constants';

export const NameValidator = (
  text: string
): { error: string; validity: boolean } => {
  if (text && text.length >= 3) return VALIDATOR_SUCCESS;
  return { ...VALIDATOR_FAILURE, error: MINIMUM_NAME_LENGTH_ERROR };
};

export const PhoneValidator = (
  text: string
): { error: string; validity: boolean } => {
  if (text && text.length == 10) return VALIDATOR_SUCCESS;
  return { ...VALIDATOR_FAILURE, error: PHONE_NUMBER_ERROR };
};

export const OfficialEmailValidator = (
  email: string
): { error: string; validity: boolean } => {
  const emailValidity = EmailValidator(email);

  if (emailValidity.validity) {
    const domain = email.split('@')[1];
    if (domain && CONSTANTS.BLACKLIST.includes(domain)) {
      return { ...VALIDATOR_FAILURE, error: PROFESSIONAL_EMAIL_ERROR };
    }
    return VALIDATOR_SUCCESS;
  }
  return emailValidity;
};

export const EmailValidator = (
  email: string
): { error: string; validity: boolean } => {
  const atIndex = email.indexOf('@');

  if (atIndex === -1 || atIndex !== email.lastIndexOf('@')) {
    return { ...VALIDATOR_FAILURE, error: EMAIL_AT_ERROR };
  }

  const dotIndex = email.lastIndexOf('.');
  if (dotIndex === -1 || dotIndex < atIndex) {
    return { ...VALIDATOR_FAILURE, error: EMAIL_DOMAIN_ERROR };
  }
  return VALIDATOR_SUCCESS;
};

export const InterestedProductValidator = (
  tag: string
): { error: string; validity: boolean } => {
  if (tag) {
    return VALIDATOR_SUCCESS;
  } else {
    return { ...VALIDATOR_FAILURE, error: INTERESTED_PRODUCT };
  }
};

export const EmptyValidator = (
  text: string
): { error: string; validity: boolean } => {
  if (text && text.length) return VALIDATOR_SUCCESS;
  return { ...VALIDATOR_FAILURE, error: REQUIRED_FIELD_ERROR };
};
